import {icon} from './icons.js';
import {timeLabel} from '../core/utils.js';

export class BookmarkEditor extends HTMLElement {
  connectedCallback() {
    this.innerHTML = `<dialog class="bookmark-dialog" aria-labelledby="bookmark-editor-title"><form class="bookmark-name-form">
      <div class="bookmark-dialog-heading"><div><h2 id="bookmark-editor-title">Add bookmark</h2><p class="bookmark-editor-time"></p></div><button type="button" class="icon-button" data-close aria-label="Cancel bookmark">${icon('close')}</button></div>
      <label for="bookmark-editor-name">Bookmark name</label><input id="bookmark-editor-name" name="bookmarkName" maxlength="120" autocomplete="off" required autofocus>
      <div class="bookmark-dialog-actions"><button type="button" class="button ghost" data-close>Cancel</button><button type="submit" class="button accent">Save bookmark</button></div>
      </form></dialog>`;
    this.dialog = this.querySelector('dialog'); this.input = this.querySelector('input');
    this.querySelectorAll('[data-close]').forEach(button => button.onclick = () => this.dialog.close('cancel'));
    this.input.oninput = () => this.input.setCustomValidity('');
    this.querySelector('form').onsubmit = event => {
      event.preventDefault(); const name = this.input.value.trim();
      this.input.setCustomValidity(!name ? 'Enter a bookmark name.' : this.validate?.(name) || '');
      if (this.input.reportValidity()) this.dialog.close('save');
    };
  }
  open({name, time, editing = false, validate}) {
    if (this.dialog.open) return Promise.resolve(null);
    this.validate = validate; this.input.setCustomValidity(''); this.input.value = name;
    this.querySelector('h2').textContent = editing ? 'Rename bookmark' : 'Add bookmark';
    this.querySelector('.bookmark-editor-time').textContent = `At ${timeLabel(time, true)}`;
    const view = this.ownerDocument.defaultView, scroll = {left:view.scrollX, top:view.scrollY};
    this.dialog.returnValue = ''; this.dialog.showModal();
    this.input.focus({preventScroll:true}); this.input.select(); view.scrollTo(scroll);
    return new Promise(resolve => this.dialog.addEventListener('close', () => {
      const result = this.dialog.returnValue === 'save' ? this.input.value.trim() : null;
      view.scrollTo(scroll); resolve(result);
    }, {once:true}));
  }
}
customElements.define('mt-bookmark-editor', BookmarkEditor);
